// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"67b8c97e","1702":"67b8c97e","2399":"67b8c97e","6978":"67b8c97e","9807":"67b8c97e"}[chunkId] + ".chunk.css";
};